module.exports = __webpack_public_path__ + "media/images/product/p_k-4a11407689d59842f3a7508bf29605d2.png";